import classService from "../../1_BSZFinderApp/services/api/class.service";
import subjectService from "../../1_BSZFinderApp/services/api/subject.service";
import teacherService from "../../1_BSZFinderApp/services/api/teacher.service";

import projectService from "./api/project.service";

const bszPlannerService = {
  ...teacherService,
  ...subjectService,
  ...classService,
  ...projectService,
};

export default bszPlannerService;
